import { render, staticRenderFns } from "./ShareholderListView.vue?vue&type=template&id=f3d827b0&scoped=true"
import script from "./ShareholderListView.vue?vue&type=script&lang=js"
export * from "./ShareholderListView.vue?vue&type=script&lang=js"
import style0 from "./ShareholderListView.vue?vue&type=style&index=0&id=f3d827b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d827b0",
  null
  
)

export default component.exports